import { Injectable } from "@angular/core";
import { RecordingService } from "../recording/recording.service";
import { Subject, Observable } from "rxjs";
import { Recording } from "../../domain/recording";
import { RecordingJob } from "../../domain/recording-job";

@Injectable()
export class MediaService {
  private recordingStatusChanged: Subject<Recording>;
  constructor(private recordingService: RecordingService) {}
  init(): void {
    if (!this.recordingStatusChanged) {
      this.recordingStatusChanged = new Subject<Recording>();
      this.recordingService
        .getRecordingJobUpdatedObserver()
        .subscribe((id: string) => {
          if (id && id.length > 0) {
            console.log(
              "MediaService-> Start getting the recording job id: ",
              id,
            );
            this.recordingService
              .get(null, null, null, null, id, null)
              .then((x) => x[0])
              .then((recordingJob: RecordingJob) => {
                if (recordingJob) {
                  recordingJob.recordings.forEach((record) => {
                    this.recordingStatusChanged.next(record);
                  });
                }
              });
          }
        });
    }
  }
  getRecordingStatusChangedObservable(): Observable<Recording> {
    if (this.recordingStatusChanged) {
      return this.recordingStatusChanged.asObservable();
    }
    return null;
  }
}
